<template>
  <div>
    <ContentHeader title="Minimum Requirement Configuration" />
    <table-skeleton v-if="loading"></table-skeleton>
    <section class="content" v-else>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card w-100" style="overflow-x:hidden !important;">
              <div class="card-header">
                <div class="row w-100">
                  <div class="col-md-6">
                    <router-link
                      v-if="cps.length < 3"
                      :to="{
                        name: 'AddConfiguration',
                      }"
                      class="btn btn-success rounded-pill add-button"
                      ><i class="fas fa-plus mr-2"></i>Add Configuration</router-link
                    >
                  </div>
                  <div class="col-md-6 d-flex justify-content-end">
                    <div class="input-group input-search">
                      <input
                        type="text"
                        name="search"
                        class="form-control"
                        placeholder="Search"
                        v-model="table.filter"
                      />

                      <div class="input-group-append">
                        <button type="submit" class="btn btn-default">
                          <i class="fas fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive p-0 w-100">
                <div style="overflow-y:scroll;" class="w-100">
                  <b-table
                    hover
                    :items="cps"
                    :fields="table.fields"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    :filter="table.filter"
                    :filter-included-fields="[
                      'ib_level',
                      'min_investor',
                      'min_deposit',
                    ]"
                    @filtered="onFiltered"
                    show-empty
                  >
                    <template #empty="scope">
                      <p class="text-center">
                        {{ scope.emptyText }}
                      </p>
                    </template>
                    <template #emptyFiltered="scope">
                      <p class="text-center">
                        {{ scope.emptyFilteredText }}
                      </p>
                    </template>
                    <template #cell(No)="data">
                      {{
                        (table.currentPage - 1) * table.perPage + data.index + 1
                      }}
                    </template>
                    <template v-slot:cell(ib_level)="data">
                      <span
                        v-if="!data.item.ib_level"
                        class="badge badge-pill badge-danger"
                        >EMPTY</span
                      >
                      <span
                        v-else-if="data.item.ib_level == 'PARTNER_IB'"
                        class="badge badge-pill badge-info"
                        >Supervisor Area</span
                      >
                      <span
                        v-else-if="data.item.ib_level == 'INTRODUCING_BROKER'"
                        class="badge badge-pill badge-warning"
                        >Agent Level</span
                      >
                      <span
                        v-else-if="data.item.ib_level == 'MASTER_IB'"
                        class="badge badge-pill badge-success"
                        >Manager Area</span
                      >
                      <span
                        v-else-if="data.item.ib_level == 'SUB_PARTNER_IB'"
                        class="badge badge-pill badge-info"
                        >SUB Supervisor Area</span
                      >
                    </template>
                    <template v-slot:cell(min_investor)="data">
                      {{ data.item.min_investor }}
                    </template>
                    <template v-slot:cell(min_deposit)="data">
                      {{ data.item.min_deposit }}
                    </template>
                    <template v-slot:cell(updated_at)="data">
                      {{ new Date(data.item.updated_at).toUTCString() }}
                    </template>
                    <template v-slot:cell(Action)="data">
                      <router-link
                        :to="{
                          name: 'UpdateConfiguration',
                          params: { id: data.item.id },
                        }"
                        class="mr-3"
                      >
                        <i class="fas fa-pencil-alt text-info"></i>
                      </router-link>
                    </template>
                  </b-table>
                </div>
              </div>
              <b-pagination
                v-model="table.currentPage"
                :total-rows="table.totalRows"
                :per-page="table.perPage"
                class="my-0 p-3"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TableSkeleton from "@/components/loading-screen/TableSkeleton.vue";
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import apiClient from "../../services/ApiServices";

export default {
  components: {
    ContentHeader,
    TableSkeleton
  },

  data() {
    return {
      cps: [],
      table: {
        loading: false,
        currentPage: 1,
        totalRows: 1,
        perPage: 10,
        filter: "",
        fields: [
          "No",
          {
            key: "ib_level",
            sortable: true,
            label: 'Agent Level',
          },
          {
            key: "min_investor",
            sortable: true,
          },
          {
            key: "min_deposit",
            sortable: true,
          },
          {
            key: "updated_at",
            sortable: true,
          },
          "Action",
        ],
      },
    };
  },
  created() {
    document.title = "List Configuration - Manager Cabang";
  },

  async mounted() {
    try {
      let cpConfigList = await apiClient.get(
        `configurations?corporate_partner_id=${this.$user_id}`
      );
      console.log(cpConfigList)
      this.cps = cpConfigList.data.data.sort(function (a, b) {
        return (
          new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
        );
      });
      this.table.totalRows = this.cps.length;
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.data.data.message,
        "error"
      );
    } finally {
      this.loading = false
    }
  },

  methods: {
    onFiltered(items) {
      this.table.totalRows = items.length;
      this.table.currentPage = 1;
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .card-header {
    flex-direction: column;
    align-items: center;
  }
  .add-button {
    width: 100%;
    margin-bottom: 0.75rem;
  }
  .input-search {
    width: 100% !important;
  }
}
.card-header {
  display: flex;
  justify-content: space-between;
}
.card-header::after {
  display: none !important;
  content: "";
}
.input-search {
  width: 250px;
}
</style>
